if (!customElements.get('product-specifications')) {
  customElements.define(
    'product-specifications',
    class ProductSpecifications extends HTMLElement {
      unsubscribeVariantChange = undefined;
      abortController = undefined;

      connectedCallback() {
        this.unsubscribeVariantChange = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange.bind(this)
        );
      }

      disconnectedCallback() {
        this.unsubscribeVariantChange?.();
        this.abortController?.abort();
      }

      handleVariantChange({ data: { variant } }) {
        if (!variant?.id) return;

        // Build fetch URL for this section with the new variant
        const url = `${this.dataset.url}?variant=${variant.id}&section_id=${this.sectionId}`;
        this.renderUpdatedSpecifications(url);
      }

      renderUpdatedSpecifications(url) {
        // Cancel any in-progress request
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(url, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newSpec = html.querySelector(
              `product-specifications[data-section="${this.dataset.section}"]`
            );

            if (newSpec) {
              // Optionally animate or transition
              this.replaceContent(newSpec.innerHTML);
            }
          })
          .catch((error) => {
            if (error.name !== 'AbortError') console.error(error);
          });
      }

      replaceContent(innerHTML) {
        // Optional: fade out -> replace -> fade in
        this.classList.add('opacity-0', 'transition-opacity');
        setTimeout(() => {
          this.innerHTML = innerHTML;

          // Initialize the theme controllers on the replacement markup.
          window.thundertech.instantiateControllers();

          this.classList.remove('opacity-0');
        }, 150);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
